import React, { useEffect, useState, useCallback, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import 'moment/locale/de';
import stylelist from "stylelist";
import { useHistory, useParams, Link } from "react-router-dom";
import { add_new_slot, delete_slot, update_slot } from "../../actions/Slots";
import { copy, getSlotDate, getSlotMetaFromId } from "../../libs/SlotUtils";
import UserSelector from "./UserSelector";
import axios from "axios";
import Expenses from "../Expenses/ExpenseProject";
import SyncConstants from "../../constants/SyncConstants";
import { set_notification } from "../../actions/Sync";
import { Activities } from "../../constants/ExpenseConstants";
import useAuthentication from "../../hooks/useAuthentication";


const ExpenseMask = memo((props) => {

    const [selectedProject, setSelectedProject] = useState(null);
    const [newSelectedProject, setNewSelectedProject] = useState(null);
    const [showNewProjectSelector, setShowNewProjectSelector] = useState(false);
    const [startProjectId, setStartProjectId] = useState(props.customerId || "1");
    const UserSettings = useSelector((state) => state.User);
    const Team  = useSelector((state) => state.Team);

    const [updateId, setUpdateId] = useState(-1);
    const [title, setTitle] = useState("");
    const [durationHours, setDurationHours] = useState("0");
    const [durationMinutes, setDurationMinutes] = useState("0");
    const [wasRounded, setWasRounded] = useState(false);
    const [expenseDate, setExpenseDate] = useState (getSlotDate(new Date));
    const [activity, setActivity] = useState(Team[UserSettings.userName].defaultActivity);
    const [isWaiting, setIsWaiting] = useState(false);
    const Auth = useAuthentication();

    const [bookForOther, setBookForOther] = useState(false);
    const [selectedPerson, setSelectedPerson] = useState(UserSettings.userName);

    const [updateOrNew, setUpdateOrNew] = useState("new");

    const dispatch = useDispatch();
    
    const roundUpToQuarterHour = (minutes) => {
        const validQuarters = [0, 15, 30, 45];
        const numMinutes = parseInt(minutes) || 0;
        
        if (validQuarters.includes(numMinutes)) {
            return { rounded: numMinutes, wasRounded: false };
        }
        
        if (numMinutes < 15) return { rounded: 15, wasRounded: true };
        if (numMinutes < 30) return { rounded: 30, wasRounded: true };
        if (numMinutes < 45) return { rounded: 45, wasRounded: true };
        if (numMinutes < 60) return { rounded: 0, wasRounded: true, addHour: true };
        
        return { rounded: numMinutes % 60, wasRounded: false };
    };
    
    const handleMinutesChange = (value) => {
        setDurationMinutes(value);
        setWasRounded(false);
    };
    
    const handleMinutesBlur = (value) => {
        const { rounded, wasRounded, addHour } = roundUpToQuarterHour(value);
        setDurationMinutes(rounded.toString());
        setWasRounded(wasRounded);
        
        if (addHour) {
            const currentHours = parseInt(durationHours) || 0;
            setDurationHours((currentHours + 1).toString());
        }
    };
    
    useEffect(() => {
        if(props.slotId) {
            setExpenseDate(getSlotMetaFromId(props.slotId).slotDate);
        }else {
            setExpenseDate(getSlotDate(new Date()));
        }

        if (props.forProject != undefined) {
                setSelectedProject(props.forProject)
        }

        if(props.update == true){
            setUpdateOrNew("update");
            setUpdateId(props.updateEntry.id);
            setTitle(props.updateEntry.comment);
            setActivity(props.updateEntry.activity);
            setSelectedProject({id : props.updateEntry.expense_project_id});
            setDurationHours(Math.floor(props.updateEntry.minutes / 60).toString().padStart(2,"0"));
            setDurationMinutes((props.updateEntry.minutes % 60).toString().padStart(2,"0"));
            setExpenseDate(props.updateEntry.date);
            setSelectedPerson(props.updateEntry.person);
        }
    }, []);

    const sendToServer = useCallback(() => {
        setIsWaiting(true);

        const requestData = {
            title : title,
            updateId : updateId,
            durationHours : durationHours,
            durationMinutes : durationMinutes,
            expenseProjectId : newSelectedProject ? newSelectedProject.id : selectedProject.id,
            person : updateOrNew === "update" ? selectedPerson : (bookForOther ? selectedPerson : UserSettings.userName),
            slotId : (props.slotId == undefined || props.slotId === "") ? (props.updateEntry ? props.updateEntry.slot_id : null) : props.slotId,
            expenseDate : expenseDate,
            entryDate : getSlotDate(new Date()),
            activity : activity
        };

        // Only add bookedBy if booking for someone else AND creating a new entry (not updating)
        if (bookForOther && updateOrNew === "new") {
            requestData.bookedBy = UserSettings.userName;
        }

        axios({
            method: "post",
            auth:Auth.getAuthObject(),
            url: SyncConstants["syncBaseURL"] + "expenseEntry",
            responseType: 'json',
            data: requestData
        }).then((response) => {
            setTitle("");
            setDurationHours(0);
            setDurationMinutes(0);
            setWasRounded(false);
            setExpenseDate(getSlotDate(new Date()));
            setSelectedProject(null);
            dispatch(set_notification("Erfolgreich gespeichert", "success"));
            props.afterSubmit(newSelectedProject ? true : false);
            setIsWaiting(false);
        }).catch(response => {
            setIsWaiting(false);
        });
    }, [title, updateId, durationHours, durationMinutes, newSelectedProject, selectedProject, props, UserSettings, expenseDate, activity, bookForOther, selectedPerson, dispatch])

    return <>
        <form>
            <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <h6>Tätigkeit</h6>
                            <input type="text" className="form-control" value={title} onChange={e => {setTitle(e.target.value)}} />
                            <span className="small text-muted ms-1">Beschreibung der durchgeführten Tätigkeit.</span>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="form-group">
                            <h6>Datum</h6>
                            <input type="date" className="form-control" value={expenseDate} onChange={e => {setExpenseDate(e.target.value)}} />
                            <span className="small text-muted ms-1">Datum der Buchung.</span>
                        </div>
                    </div>
                </div>

            <div className="row">
                <div className="col-6">
                    <div className="form-group mt-4">
                        <h6>Dauer</h6>

                        <div className="row">
                            <div className="col-5">
                                <input type="text" placeholder="Stunden" className="form-control" value={durationHours} onChange={e => {setDurationHours(e.target.value)}} />
                                <span className="small text-muted ms-1">Stunden</span>
                            </div>
                            <div className="col-5">
                                <input type="text" placeholder="Minuten" className="form-control" value={durationMinutes} onChange={e => {handleMinutesChange(e.target.value)}} onBlur={e => {handleMinutesBlur(e.target.value)}}/>
                                <span className="small text-muted ms-1">
                                    {wasRounded ? "Auf nächste 15. Min aufgerundet" : "Minuten"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-6">
                    <div className="form-group mt-4">
                        <h6>Tätigkeit</h6>
                            <select value={activity} className="form-select" onChange={e => { setActivity(e.target.value) }}>
                                {Object.keys(Activities).map(key => {
                                    return <>
                                        <option value={key}>{Activities[key]}</option>
                                    </>
                                })}

                            </select>
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12">
                    <div className="form-group">
                        {updateOrNew === "new" && (
                            <>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="bookForOtherCheck"
                                        checked={bookForOther}
                                        onChange={e => {
                                            setBookForOther(e.target.checked);
                                            if (!e.target.checked) {
                                                setSelectedPerson(UserSettings.userName);
                                            }
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="bookForOtherCheck">
                                        Für andere Person buchen
                                    </label>
                                </div>

                                {bookForOther && (
                                    <div className="mt-2">
                                        <select
                                            value={selectedPerson}
                                            className="form-select"
                                            onChange={e => { setSelectedPerson(e.target.value) }}
                                        >
                                            {Object.keys(Team)
                                                .sort((a, b) => Team[a].realName.localeCompare(Team[b].realName))
                                                .map(username => (
                                                    <option key={username} value={username}>
                                                        {Team[username].realName}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                        <span className="small text-muted ms-1">
                                            Wird als {Team[UserSettings.userName].realName} für {Team[selectedPerson]?.realName} gebucht
                                        </span>
                                    </div>
                                )}
                            </>
                        )}
                        
                        {updateOrNew === "update" && (
                            <div className="alert alert-info">
                                <i className="bi bi-info-circle me-2"></i>
                                Person: <strong>{Team[selectedPerson]?.realName || selectedPerson}</strong>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="form-group mt-4">
            <h6>Projekt</h6>

                {updateOrNew == "new" && 
                    <>
                       
                        {Boolean(selectedProject !== null ) &&
                            <div className="small">
                                {selectedProject.title} &nbsp; 
                                
                                {!props.hideDeleteButton &&
                                    <>
                                        (<span className="text-danger cursor-pointer" onClick={() => {setSelectedProject(null)}}>Löschen</span>)
                                
                                    </>
                                }
                                
                            </div>
                        }

                        {selectedProject == null &&
                            <>
                                {Boolean(props.customerId) && startProjectId !== "1" && (
                                    <div className="mb-3">
                                        <button
                                            onClick={() => setStartProjectId("1")}
                                            className="btn btn-sm btn-outline-secondary"
                                            title="Alle Kunden anzeigen"
                                        >
                                            <i className="bi bi-arrow-left"></i> Alle Kunden anzeigen
                                        </button>
                                    </div>
                                )}
                                <Expenses
                                    key={startProjectId}
                                    onProjectSelect={p => { debug(p) }}
                                    expenseProjectId={startProjectId}
                                    level="1"
                                    filterDateFrom={false}
                                    filterDateTo={false}
                                    filterPerson={false}
                                    selectMode={true}
                                    onSelect={(e) => { setSelectedProject(e) }}
                                />
                            </>
                        }
                        </>
                }

                {updateOrNew == "update" &&
                    <>
                        {(showNewProjectSelector && newSelectedProject == null) &&
                            <>
                                {Boolean(props.customerId) && startProjectId !== "1" && (
                                    <div className="mb-3">
                                        <button
                                            onClick={() => setStartProjectId("1")}
                                            className="btn btn-sm btn-outline-secondary"
                                            title="Alle Kunden anzeigen"
                                        >
                                            <i className="bi bi-arrow-left"></i> Alle Kunden anzeigen
                                        </button>
                                    </div>
                                )}
                                <Expenses
                                        key={startProjectId}
                                        onProjectSelect={p => { debug(p) }}
                                        expenseProjectId={startProjectId}
                                        level="1"
                                        filterDateFrom={false}
                                        filterDateTo={false}
                                        filterPerson={false}
                                        selectMode={true}
                                        onSelect={(e) => { setNewSelectedProject(e) ; console.log(e); ; setShowNewProjectSelector(false); }}
                                    />
                            </>
                        }    

                        {!showNewProjectSelector && newSelectedProject != null &&
                            <>
                                <p>Die Projekt-ID wird beim Speichern auf <b>{newSelectedProject.title}</b> geändert.</p>
                            </>
                        }        

                        {!showNewProjectSelector && newSelectedProject == null &&
                            <>
                              <div className="small text-primary cursor-pointer" onClick={() => {setShowNewProjectSelector(true)}}>Projekt ändern</div>
                            </>
                        }        
                    </>
                
                }
            </div>

            <div className="form-group mt-3">
                {(title != "" && selectedProject != null && durationHours != "" && durationMinutes != "") && 
                    <>
                        {isWaiting && 
                            <>
                                <div className="btn btn-secondary btn-sm" onClick={() => {alert("Es wird aktuell auf eine Antwort vom Server gewartet.")}}>
                                    <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                </div> 
                            </>
                        }
                
                        {!isWaiting && 
                            <>
                                <div className="btn btn-secondary btn-sm" onClick={() => {sendToServer();}}>Senden</div>
                            </>
                        }
                    </>
                }

                {!(title != "" && selectedProject != null && durationHours != "" && durationMinutes != "") && 
                    <>
                        <div className="btn btn-sm btn-secondary small muted cursor-na">Alle Felder zum Absenden ausfüllen.</div>
                    </>
                }
            </div>
        </form>
    </>


});

ExpenseMask.displayName = 'ExpenseMask';

export default ExpenseMask;